<template>
  <div>
    <el-page-header @back="goBack" content="测评结果设置"></el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span>分类：</span>
          <span class="glay"
          >{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
          >
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>名称：</span>
            <span class="glay">{{ detalisObj.name }}</span>
          </div>
          <div class="fl1">
            <span> 标识：</span>
            <span class="glay">{{ detalisObj.examId }}</span>
          </div>
        </div>

        <div class="flex-box pub-line">
          <div class="fl1">
            <span>解析：</span>
            <span class="glay">{{ detalisObj.schemeName }}</span>
          </div>
          <div class="fl1">
            <span> 题目：</span>
            <span class="glay"
            >共 <i>{{ detalisObj.questions }}</i
            >题，<i>{{ detalisObj.maxScore }}</i
            >分</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="topic-outer">
      <div class="appraisal-center fonts marr">
        <div>
          <span>维度：</span>
          <span>
            <el-tag
                :class="{ 'tag-marr': true, activeBg: tagIndex == index }"
                v-for="(item, index) in getWDData"
                :key="item.examDimensionId"
                @click="activeEvent(index, item.code, item.name)"
                effect="plain"
            > {{ item.name }}</el-tag
            >
          </span>
        </div>

        <div style="margin-top: 20px">
          <el-button type="success" size="small" @click="handleClick('add')"
          >添加结果<i class="el-icon-plus"></i
          ></el-button>
          <!-- <span class="subject">共<i>10</i> 题，<i>30</i>分</span> -->
          <span class="subject"
          >共 <i>{{ tagIndex == 0 ? detalisObj.questions : emptyShow(getWDData[tagIndex]).questions }}</i> 题，<i>{{
              tagIndex == 0 ? detalisObj.maxScore : emptyShow(getWDData[tagIndex]).maxScore
            }}</i
          >分
          </span>
        </div>

        <div style="margin-top: 20px">
          <div class="public-table-data">
            <el-table
                ref="multipleTable"
                size="medium"
                :data="getWdResulData"
                border
                style="width: 100%"
                row-key="menuId"
                v-loading="loading"
            >
              <el-table-column
                  type="index"
                  label="序号"
                  width="80"
                  align="center"
              >
              </el-table-column>
              <el-table-column
                  prop="minScore"
                  label="最小值"
                  width="120"
                  align="center"
              >
              </el-table-column>

              <el-table-column
                  prop="maxScore"
                  label="最大值"
                  width="120"
                  align="center"
              >
              </el-table-column>

              <el-table-column
                  prop="beatVal"
                  label="击败率"
                  width="150"
                  align="center"
              >
              </el-table-column>

              <el-table-column
                  prop="title"
                  label="标题"
                  width="200"
                  align="center"
              >
                <template slot-scope="scope">
                  <div v-html="scope.row.title"></div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="content"
                  label="内容"
                  min-width="200"
                  align="center"
              >
                <template slot-scope="scope">
                  <div v-html="scope.row.content"></div>
                </template>
              </el-table-column>

              <el-table-column
                  prop="descr"
                  label="解析"
                  min-width="400"
                  align="center"
              >
                <template slot-scope="scope">
                  <div v-html=" $options.filters.ellipsis(scope.row.descr) "
                       style="white-space: nowrap; text-overflow:ellipsis; overflow:hidden;"></div>
                </template>
              </el-table-column>

              <el-table-column
                  prop="suggest"
                  label="建议"
                  min-width="400"
                  align="center"
              >
                <template slot-scope="scope">
                  <div v-html=" $options.filters.ellipsis(scope.row.suggest) "
                       style="white-space: nowrap; text-overflow:ellipsis; overflow:hidden;"></div>
                </template>
              </el-table-column>

              <el-table-column
                  prop="suggest"
                  label="练习"
                  min-width="400"
                  align="center"
              >
                <template slot-scope="scope">
                  <div v-html=" $options.filters.ellipsis(scope.row.guideSuggest) "
                       style="white-space: nowrap; text-overflow:ellipsis; overflow:hidden;"></div>
                </template>
              </el-table-column>
              <el-table-column
                  label="操作"
                  align="center"
                  fixed="right"
                  min-width="240"
              >
                <template slot-scope="scope">
                  <el-button
                      size="mini"
                      @click="handleClick('edit', scope.row)"
                      type="primary"
                      plain
                  >编辑
                  </el-button
                  >
                  <el-button
                      v-if="scope.$index<=4 && detalisObj.examId=='LHXG'"
                      size="mini"
                      @click="conditionClick(scope.row)"
                      type="success"
                      plain
                  >条件
                  </el-button
                  >
                  <el-button
                      size="mini"
                      @click="handleDelete(scope.row)"
                      type="danger"
                      plain
                      v-if="numType"
                  >删除
                  </el-button
                  >
                  <el-button
                      v-else
                      size="mini"
                      @click="operationShowTime"
                      type="danger"
                      plain
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
        title="结果设置"
        :visible.sync="dialogVisible"
        width="860px"
        top="30px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-tabs type="card" v-model="languageCode" @tab-click="handleTabClick">
            <el-tab-pane v-for="(item,index) in languageList" :label="item.name" :name="item.code"
                         :key="index"></el-tab-pane>
          </el-tabs>
          <el-form-item label="维度">
            <div>{{ resue.name }}</div>
          </el-form-item>
          <el-form-item label="分值" prop="minScore">
            <el-input
                placeholder="请填最低分值"
                v-model="params.minScore"
                style="width: 262px"
            ></el-input>
            -
            <el-input
                placeholder="请填最高分值"
                v-model="params.maxScore"
                style="width: 262px"
            ></el-input>
          </el-form-item>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="名称" prop="name">
                <el-input
                    placeholder="请输入名称"
                    v-model="params.name"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="动物图片" prop="beatVal" v-if="detalisObj.examId=='LHXG'">
            <div class="diplay" style="margin-right: 10px">
              <div class="screenshot">
                <span class="slideshow" v-for="(imgUrl, index) in srcList"
                      :key="index">
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicy"
                  />
                </span>
                <div
                    class="up-btn"
                    style="width: 75px; height: 75px; line-height: 80px"
                    @click="getPolicy"
                    v-if="!params.icon"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input
                  type="file"
                  ref="file"
                  @change="getFile"
                  accept="image/png,image/jpg"
              />
            </div>
          </el-form-item>
          <!-- <el-form-item label="击败率" prop="beatVal">
            <el-input
              placeholder="请填写名称"
              v-model="params.beatVal"
              style="width: 262px"
            ></el-input>
            %
          </el-form-item> -->
          <el-form-item label="标题" prop="title">
            <rich-text v-if="innerVisible" :keyWord="'title'" :params="params?params:''"></rich-text>
          </el-form-item>
          <el-form-item label="内容" prop="content">
            <rich-text v-if="innerVisible" :keyWord="'content'" :params="params?params:''"></rich-text>
          </el-form-item>
          <el-form-item label="解析" prop="descr">
            <rich-text v-if="innerVisible" :keyWord="'descr'" :params="params?params:''"></rich-text>
          </el-form-item>
          <el-form-item label="建议" prop="suggest">
            <rich-text v-if="innerVisible" :keyWord="'suggest'" :params="params?params:''"></rich-text>
          </el-form-item>
          <el-form-item label="练习" prop="guideSuggest">
            <rich-text v-if="innerVisible" :keyWord="'guideSuggest'" :params="params?params:''"></rich-text>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
        title="条件设置"
        :visible.sync="conditionDialogVisible"
        width="660px"
        top="30px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form_tans">
        <div class="title_dun_dime">解析条件</div>
        <div class="title_dun_dime">动物：<span v-html="conditionInfo.title"></span></div>
        <div class="dimension_box">
          <div class="dimension_box_title">维度组合：</div>
          <div class="dimension_box_lis">
            <div class="dimension_content_list" v-for="(item,index) in conditionWDData" :key="index">
              <div class="dimension_title_info">{{ item.name }}</div>
              <template>
                <el-radio-group v-model="item.checkRadio">
                  <el-radio :label="1">高</el-radio>
                  <el-radio :label="0">低</el-radio>
                </el-radio-group>
              </template>
            </div>
            <el-button class="button_bottom" size="medium" type="primary" @click="addCondition">确定</el-button>
            <el-table
                :data="listCondition"
                border
                row-key="menuId"
                v-loading="loading"
                style="width: 100%;margin: 20px 0">
              <el-table-column
                  prop="date"
                  label="序号"
                  align="center"
                  width="50">
                <template slot-scope="scope">
                  <span>{{scope.$index+1}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="conditionName"
                  label="维度组合"
                  align="center"
                  width="350">
              </el-table-column>
              <el-table-column
                  prop="address"
                  label="操作"
                  align="center"
                  width="100"
              >
                <template slot-scope="scope">
                  <el-button
                      size="mini"
                      plain
                      @click="deleteCondition(scope.row)"
                      v-if="numType"
                  >删除
                  </el-button
                  >
                  <el-button
                      size="mini"
                      plain
                      v-else
                      @click="operationShowTime"
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <operation-confirmation  @closeOperation="publicMethios" :operationVisible="operationVisible"></operation-confirmation>
  </div>
</template>
<script>

import {isEmpty, emptyShow} from "@utils/tools/index";
import {ossUpload} from "@utils/filters/upload";
import OperationConfirmation from "../../../components/OperationConfirmation";
import richText from "../../../components/richText";
export default {

  filters: {
    //日期过滤
    // formatDate(time) {
    //   if (time) {
    //     let date = new Date(time);
    //     return formatDate(date, 'yyyy-MM-dd hh:ss:mm');
    //   }
    // },
    //当渲染的文字超出30字后显示省略号
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 60) {
        return value.slice(0, 60) + "...";
      }
      return value;
    }
  },


  data() {
    return {
      innerVisible:false,
      //灵魂条件
      isMoer: true,
      srcList: [],
      conditionDialogVisible: false,
      conditionWDData: [],
      conditionInfo: {},
      listCondition: [],
      //之前的代码
      emptyShow, isEmpty,
      detalisObj: {},
      getWDData: [], //维度列表
      getWdResulData: [], //维度结果列表
      tagIndex: 0,
      resue: {},
      loading: false,
      dialogVisible: false,
      params: {
        icon:''
      },
      clickType: "",
      rules: {
        minScore: [
          {
            required: true,
            message: "请填写正确的分值",
            trigger: "change",
          },
        ],
      },
      operationVisible:false,
      numType:false,
      languageList: [],
      languageCode:"",
    };
  },
  components: {
    OperationConfirmation,
    richText
  },
  computed:{
    conditionKey(){
      let arr = []
      if(this.detalisObj.examId=='LHXG'){
        if(this.conditionWDData.length){
          this.conditionWDData.map(item=>{
            let obj_txt = item.code + '-' + item.checkRadio
            arr.push(obj_txt)
          })
        }
      }
      return arr.join()
    },
    conditionName(){
      let arr = []
      if(this.detalisObj.examId=='LHXG'){
        if(this.conditionWDData.length){
          this.conditionWDData.map(item=>{
            let obj_txt = item.name + (item.checkRadio==1?'(高)':'(低)')
            arr.push(obj_txt)
          })
        }
      }
      return arr.join()
    }
  },

  created() {
    this.getAppraisalData();
    this.getWDList();
    this.getLanguageList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.innerVisible = false
      }
    },
  },
  methods: {

    //获取语言列表
    async getLanguageList() {
      this.loading = true;
      //角色列表
      const {data: res} = await this.$post(
          `/language/list`, {adminStatus: 1},
      );
      this.loading = false;
      this.languageList = res.data;
      this.languageCode = res.data[0].code
    },
    handleTabClick(){
      this.innerVisible = false;
      this.srcList = []
      if(this.params.examResultId){
        this.getRustInfo(this.params)
      }else {
        this.$nextTick(() => {
          this.innerVisible = true;
        });
      }
    },
    //清楚缓存数据，重启密码验证
    clearStore(){
      window.sessionStorage.removeItem('operationKey')
      this.numType = false
    },
    //关闭
    publicMethios(e){
      this.operationVisible = false
      if(e=='open'){
        this.numType = true
        setTimeout(()=>{
          window.sessionStorage.removeItem('operationKey')
          this.numType = false
        },1800000)
      }
    },
    //调起字组件的操作密码框
    operationShowTime(e){
      this.operationVisible = true
    },
    //添加条件
    async addCondition(){
      let params = {
        conditionKey:this.conditionKey,
        conditionName:this.conditionName,
        examResultId:this.conditionInfo.examResultId,
      }
      this.loading = true;
      const {data: resData} = await this.$post(
          `exam/result/condition/info`,params);
      this.loading = false;
      if (resData.result != 200){
        this.$message.error(resData.message)
        return
      }
      this.getConditionList(this.conditionInfo.examResultId)
    },
    //删除条件
    async deleteCondition(e){
        this.$confirm("此操作将永久删除该测评题库数据, 是否继续?", "提示", {
          type: "warning",
        }).then(async () => {
          this.loading = true;
          const { data: resData } = await this.$delete(
              `exam/result/condition/info/${e.examResultConditionId}`);
          if (resData.result != 200) return;
          this.getConditionList(this.conditionInfo.examResultId)
          this.$message.success("删除成功!");
        }).catch(()=>{

        });
        this.clearStore()
    },
    //点击列表条件弹框
    async conditionClick(e) {
      this.conditionInfo = e
      this.conditionWDData = []
      this.getConditionList(e.examResultId)
      let arr = this.getWDData
      arr.map((item, index) => {
        if (index != 0) {
          let obj = {
            name: item.name,
            checkRadio: 1,
            examDimensionId: item.examDimensionId,
            examInfoId: item.examInfoId,
            code:item.code,
          }
          this.conditionWDData.push(obj)
        }
      })
      this.conditionDialogVisible = true
    },
    //获取到条件列表
    async getConditionList(e) {
      this.loading = true;
      const {data: resData} = await this.$get(
          `exam/result/condition/list`, {
            params: {
              examResultId: e
            }
          }
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.listCondition = resData.data;
    },
    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one", //'more','one'
          this.srcList
      );

      this.srcList = addRoutes;
      this.params.icon = this.srcList[0];
      this.isMoer = false;
    },
    /**
     * 获取测评详情
     */
    async getAppraisalData() {
      this.loading = true;

      const {data: resData} = await this.$get(
          `exam/info/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.detalisObj = resData.data;
    },
    /**
     * 获取测评维度列表
     */
    async getWDList() {
      this.getWDData = [];
      this.loading = true;
      const {data: resData} = await this.$get(`exam/dimension/list`, {
        params: {
          examId: this.$route.query.examId,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.getWDData = resData.data
      }

      /* tagIndex :激活的是哪个 维度  */
      if (this.getWDData.length != 0) {
        this.resue = {
          code: this.getWDData[this.tagIndex].code,
          name: this.getWDData[this.tagIndex].name,
        };

        if (this.tagIndex == 0) {
          this.getWdResultList(); //初始化表格
        } else {
          this.getWdResultList(this.resue.code); //初始化表格
        }

      } else {
        this.tableData = [];
        return
      }

    },
    /**
     * 获取测评维度j结果列表
     */
    async getWdResultList(examDimensionCode) {
      this.loading = true;
      let temp = {examId: this.$route.query.examId,}

      if (emptyShow(examDimensionCode) && this.tagIndex != 0) {
        temp.examDimensionCode = examDimensionCode
      }
      const {data: resData} = await this.$get(`exam/result/list`, {
        params: temp,
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (emptyShow(resData.data)) {
        this.getWdResulData = resData.data;
      } else {
        this.getWdResulData = [];
      }
    },
    /**
     * 点击维度
     */
    activeEvent(index, code, name) {
      this.tagIndex = index;

      this.params.examDimensionCode = code;
      this.getWdResultList(code);
      this.resue = {
        name,
        code,
      };
    },
    async handleClick(type, row = {}) {
      this.innerVisible = false
      this.clickType = type;
      this.dialogVisible = true;
      if (type == "add") {
        this.params = {};
        this.srcList = []
        this.innerVisible = true
      }
      if (type == "edit") {
        this.params = JSON.parse(JSON.stringify(row))
        this.getRustInfo(row)
      }
    },

    async getRustInfo(row){
      this.innerVisible = false
      const {data: resData} = await this.$get(
          `exam/result/info/${row.examResultId}`,
          {
            headers: {
              isLoading: true,
              'Language-Code':this.languageCode
            },
          }
      );
      if (resData.result != 200) return;
      this.params = resData.data;
      this.srcList = []
      if(resData.data.icon){
        this.srcList.push(resData.data.icon)
      }
      this.innerVisible = true
    },



    /**
     * 编辑/增加
     */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "add") {
            this.params.examDimensionCode = this.resue.code;
            this.params.examId = this.$route.query.examId;
            const {data: resData} = await this.$post(
                "exam/result/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                    'Language-Code':this.languageCode
                  },
                }
            );
            if (resData.result != 200) return;
            this.getWdResultList(this.resue.code);
            this.$message.success("添加成功!");
            this.params.examResultId = resData.data
            this.getRustInfo(this.params)
            // this.params = {};
            this.clickType = 'edit'
          } else {
            const {data: resData} = await this.$put(
                "exam/result/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                    'Language-Code':this.languageCode
                  },
                }
            );
            if (resData.result != 200) return;
            this.getWdResultList(this.resue.code);
            this.$message.success("修改成功!");
            this.params.examResultId = resData.data
            this.getRustInfo(this.params)
          }
        });
      });
    },
    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `exam/result/info/${row.examResultId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("删除成功!");
        this.getWdResultList(this.resue.code);
      });
      this.clearStore()
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.appraisal-title {
  color: #3a3a3a;
}

.appraisal-center {
  width: 90%;
  margin: 0 auto;
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}

.pub-marr {
  margin-top: 20px;
}

.marr {
  margin-top: 30px;
}

.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}

.subject {
  color: #8492a6;
  margin-left: 10px;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.activeBg {
  background: #b3d8ff;
  color: #fff;
}

.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}

.public-dialog-form_tans {
  .title_dun_dime {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }

  .dimension_box {
    display: flex;

    .dimension_box_lis {
      .dimension_content_list {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .dimension_title_info {
          width: 80px;
          text-align: right;
          margin-right: 10px;
        }
      }

      .button_bottom {
        margin-top: 20px;
        margin-left: 80px;
      }
    }
  }
}
</style>
